const invoiceTypeOptions = Object.freeze([
  { label: 'Time & Materials', value: 'Time & Materials' },
  { label: 'Materials Only', value: 'Materials Only' },
  { label: 'Pay App & SOV', value: 'Pay App & SOV' },
  { label: 'Per STI Quote', value: 'Per STI Quote' },
  { label: 'Negotiated Rate', value: 'Negotiated Rate' }
]);

export default invoiceTypeOptions;
